/**
 * Handoff между двумя mobile drawer/sheet (vaul): закрыть текущий и только
 * потом открыть следующий. Мгновенный open в том же тике глотает новый sheet
 * (overlay Close / focus race → «мелькнул снизу и пропал»).
 */
export const DRAWER_HANDOFF_MS = 280;

export function openAfterDrawerClose(closeCurrent: () => void, openNext: () => void): void {
	closeCurrent();
	window.setTimeout(openNext, DRAWER_HANDOFF_MS);
}
